import React from 'react';
import propTypes from 'prop-types';
import HedinIcon from '@hedinbil/hedin-ui/dist/icons/components/HedinIcon';

const FilterButton = (props) => {
  const { text, onClick, className, activeFilters } = props;

  return (
    <button
      className={`button button--clean button--filter ${className ? className : ''}`}
      onClick={onClick}
    >
      <HedinIcon
        iconName="Filter"
        className="button--filter__icon button--filter__icon-left mt-0"
      />
      <span>{text}</span>
      {activeFilters ? (
        <div
          className="button--filter-count text-center color-white"
          style={{ lineHeight: '30px' }}
        >
          <span>{activeFilters}</span>
        </div>
      ) : null}
    </button>
  );
};

FilterButton.propTypes = {
  text: propTypes.string,
  className: propTypes.string,
  onClick: propTypes.func,
  activeFilters: propTypes.number,
};

export default FilterButton;
